import { FunctionComponent, useState } from 'react';
import styles from './Checkbox.module.scss';
import clsx from 'clsx';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useNonInitialEffect from '@versiondos/hooks';

interface CheckboxProps {
    label?: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    className?: string;
}

export const Checkbox: FunctionComponent<CheckboxProps> = props => {
    useNonInitialEffect(() => {
        if (props.checked !== checked) {
            setChecked(props.checked ?? false);
        }
    }, [props.checked]);

    const [checked, setChecked] = useState(props.checked ?? false);

    const clickHandler = () => {
        const newChecked = !checked;
        setChecked(newChecked);
        props.onChange?.(newChecked);
    };

    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={clickHandler}
        >
            <FontAwesomeIcon
                icon={checked ? faSquareCheck : faSquare}
                fontSize={18}
            />
            {props.label && <span className={styles.label}>{props.label}</span>}
        </div>
    );
};

export default Checkbox;
